import { render, staticRenderFns } from "./FeatureRequestSearch.vue?vue&type=template&id=258058d1&scoped=true"
import script from "./FeatureRequestSearch.vue?vue&type=script&lang=js"
export * from "./FeatureRequestSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258058d1",
  null
  
)

export default component.exports